(function () {
'use strict';
// Q Drinks configurator v14 (Cowork 8 sep 2026) — VOLLE BREEDTE, TWEE KOLOMMEN, RUSTIG.
// LINKS: welke smaken en hoeveel doosjes per maand, met meter "hoe meer, hoe goedkoper".
// RECHTS: bezorgritme (1 of 2 maanden, elk met eigen maandbedrag) + totalen + knop.
// v11: prijsraster gelijkgetrokken met de margematrix; de badge "laagste prijs" verschijnt
// alleen als er echt één goedkoopste ritme is (bij 60 cups kosten beide hetzelfde).
// AANTALLEN ZIJN PER MAAND. De zending = aantal per maand x ritme, dus bij een ritmewissel
// hoeft er niets herschaald te worden: je box blijft, alleen levering en prijs veranderen.
// Staffel = (ritme, doosjes per maand) -> selling plan -> korting, ook bij verlenging.
// EENMALIG (31 aug, patroon De Koffiejongens): freq 0 = zelfde box, volle prijs, geen selling
// plan, geen cadeau, geen cadeaucode. Verzendkosten gelden (gratis vanaf EUR 49 -> shipnote).
// v14 (8 sep, besluit Koen): eenmalig is geen ritme-regel meer maar een gelijkwaardige
// SCHAKELAAR (#qbb7-mode-once / #qbb7-mode-abo) bovenaan; de ritmes verschijnen alleen bij
// abonnement. Bij eenmalig: verzendmeter naar EUR 49 i.p.v. de staffelmeter, extra groep
// specialties (products met extra:true, eigen prijs, alleen eenmalig meebesteld), regel onder
// de totalen met wat de ándere stand kost. Start op eenmalig via ?koop=eenmalig of data.startOnce.
function qdRoot() { try { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; } catch (e) { return '/'; } }
const S = (window.__qbb7Data && window.__qbb7Data.strings) || {};

class QdBuyBox14 {
  constructor() {
    this.data   = window.__qbb7Data;
    this.root   = document.getElementById('bab-qbb7');
    this.ctaBtn = document.getElementById('bab-cta-qbb7');
    this.ctaSub = document.getElementById('qbb7-ctasub');
    if (!this.root || !this.data) return;
    this.freqs = [];
    this.data.tiers.forEach(t => { if (this.freqs.indexOf(t.freq) === -1) this.freqs.push(t.freq); });
    this.freqs.sort((a, b) => a - b);
    this._aboFreq = this.data.defaultFreq || 2; // laatst gekozen ritme, om naar terug te keren na eenmalig
    this._startOnce = !!this.data.startOnce;
    try {
      const koop = new URLSearchParams(window.location.search).get('koop');
      if (koop === 'eenmalig' || koop === 'once') this._startOnce = true;
    } catch (e) {}
    this.state = { freq: this._startOnce ? 0 : this._aboFreq, qtys: {} };
    this._editMode = false;
    this._editBoxId = null;
    try {
      const editParam = new URLSearchParams(window.location.search).get('edit');
      if (editParam && editParam === 'box-' + this.data.parentProductId) {
        this._editMode = true;
        this._editBoxId = editParam;
      }
    } catch (e) {}
    this._initQtys();
    this._bindMode();
    this._bindFreq();
    this._bindSteppers();
    this._bindCta();
    this._fillMinCup();
    if (this._editMode) {
      this._loadFromCart().catch(err => {
        console.warn('[QdBuyBox14] edit prefill mislukt, standaard gebruikt:', err);
        this._resetToDefault();
      });
    } else {
      this._resetToDefault();
    }
  }

  _initQtys() { this.data.products.forEach(p => { this.state.qtys[String(p.variantId)] = 0; }); }
  _coffee() { return this.data.products.filter(p => !p.extra); }
  _extras() { return this.data.products.filter(p => p.extra); }
  _fillMinCup() {
    let minCents = 0;
    (this.data.tiers || []).forEach(t => { if (t.boxPriceCents > 0 && (minCents === 0 || t.boxPriceCents < minCents)) minCents = t.boxPriceCents; });
    if (!minCents) return;
    const txt = this._formatMoney(Math.floor(minCents / this.data.cupsPerBox));
    document.querySelectorAll('[data-qbb7-mincup]').forEach(el => { el.textContent = txt; });
  }
  _resetToDefault() {
    this.state.freq = this._startOnce ? 0 : (this.data.defaultFreq || 2);
    this._syncFreqButtons();
    this._prefill(this.data.defaultBoxes || 6);
  }

  // ---- staffels (op doosjes PER MAAND) ----
  _tiersFor(freq) {
    return this.data.tiers.filter(t => t.freq === freq).sort((a, b) => a.minBoxes - b.minBoxes);
  }
  _tierFor(freq, monthlyBoxes) {
    let match = null;
    this._tiersFor(freq).forEach(t => { if (monthlyBoxes >= t.minBoxes) match = t; });
    return match;
  }
  _activeTier() { return this._tierFor(this.state.freq, this._monthlyBoxes()); }
  _nextTier() {
    const mb = this._monthlyBoxes();
    return this._tiersFor(this.state.freq).find(t => t.minBoxes > mb) || null;
  }
  _minBoxes() {
    if (this.state.freq === 0) return 1; // eenmalig: geen staffelminimum, wel minstens 1 doosje
    const tiers = this._tiersFor(this.state.freq);
    return tiers.length ? tiers[0].minBoxes : 0;
  }
  _boxCents(tier) {
    if (!tier) return this.data.basePriceCents;
    if (tier.boxPriceCents > 0) return tier.boxPriceCents;
    return Math.floor(this.data.basePriceCents * (100 - (tier.savePct || 0)) / 100);
  }
  // Doosjes KOFFIE per maand — de specialties tellen niet mee voor de staffel.
  _monthlyBoxes() { return this._coffee().reduce((s, p) => s + (this.state.qtys[String(p.variantId)] || 0), 0); }
  _extrasCount() { return this._extras().reduce((s, p) => s + (this.state.qtys[String(p.variantId)] || 0), 0); }
  _extrasCents() { return this._extras().reduce((s, p) => s + (this.state.qtys[String(p.variantId)] || 0) * (p.priceCents || 0), 0); }
  _onceCoffeeCents() { return this.data.basePriceCents * this._monthlyBoxes(); }
  _onceTotalCents() { return this._onceCoffeeCents() + this._extrasCents(); }
  // Abo-referentie voor de eenmalig-stand: 2-maandelijks bij dit aantal (minimaal het staffelminimum).
  _aboReference(mb) {
    const f = this.freqs.indexOf(2) !== -1 ? 2 : (this.freqs[this.freqs.length - 1] || 1);
    const tiers = this._tiersFor(f);
    if (!tiers.length) return null;
    const min = tiers[0].minBoxes;
    const tier = this._tierFor(f, Math.max(mb, min));
    return tier ? { tier: tier, belowMin: mb < min } : null;
  }

  // ---- links: smaken ----
  _bindSteppers() {
    this.root.querySelectorAll('[data-variant-id]').forEach(productEl => {
      const vid = productEl.dataset.variantId;
      productEl.querySelector('.bab__stepper-btn--plus').addEventListener('click', e => { e.stopPropagation(); this._changeQty(vid, +1); });
      productEl.querySelector('.bab__stepper-btn--minus').addEventListener('click', e => { e.stopPropagation(); this._changeQty(vid, -1); });
    });
  }
  _changeQty(variantId, delta) {
    const newQty = (this.state.qtys[variantId] || 0) + delta;
    if (newQty < 0) return;
    this.state.qtys[variantId] = newQty;
    this._render();
  }
  _prefill(totalBoxes) {
    const coffee = this._coffee();
    const count = coffee.length;
    if (count === 0) return;
    const base = Math.floor(totalBoxes / count);
    const remainder = totalBoxes % count;
    coffee.forEach((product, i) => {
      this.state.qtys[String(product.variantId)] = base + (i < remainder ? 1 : 0);
    });
    this._render();
  }

  // ---- rechts: eenmalig/abonnement + ritme ----
  _bindMode() {
    const once = document.getElementById('qbb7-mode-once');
    const abo = document.getElementById('qbb7-mode-abo');
    if (once) once.addEventListener('click', () => this._setMode(true));
    if (abo) abo.addEventListener('click', () => this._setMode(false));
  }
  _setMode(once) {
    if (once === (this.state.freq === 0)) return;
    if (once) { this._aboFreq = this.state.freq || this._aboFreq; this.state.freq = 0; }
    else { this.state.freq = this._aboFreq || this.data.defaultFreq || 2; }
    this._syncFreqButtons();
    this._render();
  }
  _bindFreq() {
    this.freqs.forEach(f => {
      const btn = document.getElementById('qbb7-freq-' + f);
      if (!btn) return;
      btn.addEventListener('click', () => {
        if (f === this.state.freq) return;
        this.state.freq = f;
        this._aboFreq = f;
        this._syncFreqButtons();
        this._render();
      });
    });
  }
  _syncFreqButtons() {
    const once = this.state.freq === 0;
    this.freqs.forEach(f => {
      const btn = document.getElementById('qbb7-freq-' + f);
      if (btn) btn.setAttribute('aria-pressed', f === this.state.freq ? 'true' : 'false');
    });
    const mOnce = document.getElementById('qbb7-mode-once');
    const mAbo = document.getElementById('qbb7-mode-abo');
    if (mOnce) mOnce.setAttribute('aria-pressed', once ? 'true' : 'false');
    if (mAbo) mAbo.setAttribute('aria-pressed', once ? 'false' : 'true');
  }

  // ---- weergave ----
  _render() {
    const mb = this._monthlyBoxes();
    const tier = this._activeTier();
    this.data.products.forEach(p => this._renderProductEl(String(p.variantId)));
    const boxEl = this.root.querySelector('.qbb7-boxcount');
    const cupEl = this.root.querySelector('.qbb7-cupcount');
    if (boxEl) boxEl.textContent = mb;
    if (cupEl) cupEl.textContent = mb * this.data.cupsPerBox;
    this._renderMeter(mb, tier);
    this._renderGift(tier, mb);
    this._renderFreqOptions(mb);
    this._syncOnceUi();
    this._updateCta(mb, tier);
  }
  // Alles met data-abo-only / data-once-only wisselt mee met de stand: ritmes, USP's, specialties, totaalregels.
  _syncOnceUi() {
    const once = this.state.freq === 0;
    this.root.querySelectorAll('[data-abo-only]').forEach(el => { el.hidden = once; });
    this.root.querySelectorAll('[data-once-only]').forEach(el => { el.hidden = !once; });
    this.root.classList.toggle('qbb8-is-once', once);
  }
  _renderProductEl(variantId) {
    const el = this.root.querySelector('[data-variant-id="' + variantId + '"]');
    if (!el) return;
    const qty = this.state.qtys[variantId] || 0;
    const stepperQty = el.querySelector('.bab__stepper-qty');
    const qtyVal = el.querySelector('.bab__qty-val');
    const minusBtn = el.querySelector('.bab__stepper-btn--minus');
    if (stepperQty) stepperQty.textContent = qty;
    if (qtyVal) qtyVal.textContent = qty;
    if (minusBtn) minusBtn.disabled = qty <= 0;
  }
  _renderMeter(mb, tier) {
    const line = this.root.querySelector('.qbb7-tierline');
    const fill = this.root.querySelector('.qbb7-bar-fill');
    if (!line) return;
    if (this.state.freq === 0) {
      // Eenmalig: geen staffel, dus de meter wordt een VERZENDMETER naar de gratis-verzendgrens.
      const total = this._onceTotalCents();
      const free = this.data.freeShipCents || 4900;
      if (fill) fill.style.width = Math.min(100, Math.round(total / free * 100)) + '%';
      if (total >= free) {
        line.innerHTML = S.shipFree || '<b>Gratis verzending</b> — je zit boven de €49.';
      } else {
        const short = Math.max(1, Math.ceil((free - total) / this.data.basePriceCents));
        const boxWord = short === 1 ? (S.boxSingular || 'doosje') : (S.boxPlural || 'doosjes');
        line.innerHTML = (S.shipMeter || 'Nog <b>{n} {box}</b> tot gratis verzending (vanaf €49).')
          .replace('{n}', short).replace('{box}', boxWord);
      }
      return;
    }
    const min = this._minBoxes();
    const tiers = this._tiersFor(this.state.freq);
    const top = tiers.length ? tiers[tiers.length - 1].minBoxes : min;
    if (fill) fill.style.width = Math.min(100, Math.round(mb / top * 100)) + '%';
    if (!tier) {
      const short = min - mb;
      const boxWord = short === 1 ? (S.boxSingular || 'doosje') : (S.boxPlural || 'doosjes');
      line.innerHTML = (S.meterMin || 'Nog <b>{n} {box}</b> tot het minimum van {cups} cups per maand.')
        .replace('{n}', short).replace('{box}', boxWord).replace('{cups}', min * this.data.cupsPerBox);
      return;
    }
    const ppc = this._formatMoney(Math.floor(this._boxCents(tier) / this.data.cupsPerBox));
    const next = this._nextTier();
    if (next) {
      const short = next.minBoxes - mb;
      const boxWord = short === 1 ? (S.boxSingular || 'doosje') : (S.boxPlural || 'doosjes');
      const nextPpc = this._formatMoney(Math.floor(this._boxCents(next) / this.data.cupsPerBox));
      line.innerHTML = (S.meterNext || '<b>{price} per kopje</b> — nog {n} {box} tot {nextPrice}.')
        .replace('{price}', ppc).replace('{n}', short).replace('{box}', boxWord).replace('{nextPrice}', nextPpc);
    } else {
      line.innerHTML = (S.meterLowest || '<b>{price} per kopje</b> — dit is onze laagste prijs.').replace('{price}', ppc);
    }
  }
  // Twee regels onder de meter. De groene chip zegt wat je AL krijgt; daaronder staat in
  // rustige grijstint wat de volgende stap oplevert. Pas vanaf het staffelminimum en nooit
  // bij eenmalig, want freq 0 heeft geen staffels en dus geen cadeau.
  _renderGift(tier, mb) {
    const has = this.root.querySelector('.qbb7-giftline');
    const next = this.root.querySelector('.qbb7-giftnext');
    const label = tier && tier.giftLabel ? tier.giftLabel : '';
    if (has) {
      has.textContent = label;
      has.hidden = !label;
    }
    if (!next) return;
    const upcoming = tier
      ? this._tiersFor(this.state.freq).find(t => t.minBoxes > mb && t.giftShort)
      : null;
    if (!upcoming) {
      next.textContent = '';
      next.hidden = true;
      return;
    }
    const short = upcoming.minBoxes - mb;
    const boxWord = short === 1 ? (S.boxSingular || 'doosje') : (S.boxPlural || 'doosjes');
    next.textContent = (S.giftSoon || 'Nog {n} {box} tot we {gift} cadeau doen')
      .replace('{n}', short).replace('{box}', boxWord).replace('{gift}', upcoming.giftShort);
    next.hidden = false;
  }
  _renderFreqOptions(mb) {
    const cents = {};
    const savePcts = {};
    this.freqs.forEach(f => {
      const t = this._tierFor(f, mb);
      if (!t) return;
      cents[f] = this._boxCents(t) * mb;
      savePcts[f] = t.savePct || 0;
    });
    // Badge alleen als er echt één goedkoopste ritme is. Bij 60 cups kost 2-maandelijks
    // hetzelfde als maandelijks (bundelen scheelt pas verzendkosten vanaf 120), dus dan
    // hoort er geen "laagste prijs" te staan.
    const bedragen = Object.keys(cents).map(k => cents[k]);
    const laagste = bedragen.length ? Math.min.apply(null, bedragen) : null;
    const uniekLaagste = bedragen.filter(v => v === laagste).length === 1 && bedragen.length > 1;
    this.freqs.forEach(f => {
      const btn = document.getElementById('qbb7-freq-' + f);
      if (!btn) return;
      const priceEl = btn.querySelector('.qbb7-fprice');
      const badgeEl = btn.querySelector('.qbb7-fbadge');
      const saveEl = btn.querySelector('.qbb7-fsave');
      if (priceEl) priceEl.textContent = cents[f] !== undefined ? this._formatMoney(cents[f]) + (S.perMonthSuffix || ' p/mnd') : '—';
      if (badgeEl) badgeEl.hidden = !(uniekLaagste && cents[f] === laagste);
      if (saveEl) {
        const showSave = cents[f] !== undefined && mb > 0;
        saveEl.textContent = showSave ? '−' + savePcts[f] + '%' : '';
        saveEl.hidden = !showSave;
      }
    });
  }
  _renderTotals(mb, tier) {
    const cupEl = this.root.querySelector('.qbb8-t-cup');
    const monthEl = this.root.querySelector('.qbb8-t-month');
    const delivEl = this.root.querySelector('.qbb8-t-deliv');
    const delivLabel = this.root.querySelector('.qbb8-t-devlabel');
    const coffeeEl = this.root.querySelector('.qbb8-t-coffee');
    const coffeeLabel = this.root.querySelector('.qbb8-t-coffeelabel');
    const extrasEl = this.root.querySelector('.qbb8-t-extras');
    const extrasLabel = this.root.querySelector('.qbb8-t-extraslabel');
    const extrasRow = extrasEl ? extrasEl.parentElement : null;
    const cross = this.root.querySelector('.qbb7-cross');
    const delivRow = delivEl ? delivEl.parentElement : null;
    const monthRow = monthEl ? monthEl.parentElement : null;
    if (monthRow) monthRow.hidden = (this.state.freq === 0);
    if (this.state.freq === 0) {
      // Eenmalig: volle prijs per kopje, regel koffie, regel specialties (alleen als >0), één totaal.
      const ex = this._extrasCount();
      const totalCents = this._onceTotalCents();
      if (cupEl) cupEl.textContent = this._formatMoney(Math.floor(this.data.basePriceCents / this.data.cupsPerBox));
      if (coffeeLabel) coffeeLabel.textContent = (S.rowCoffee || 'Koffie ({n} doosjes)').replace('{n}', mb);
      if (coffeeEl) coffeeEl.textContent = mb > 0 ? this._formatMoney(this._onceCoffeeCents()) : '—';
      if (extrasRow) extrasRow.hidden = ex === 0;
      if (extrasLabel) extrasLabel.textContent = (S.rowExtras || 'Specialties ({n})').replace('{n}', ex);
      if (extrasEl) extrasEl.textContent = this._formatMoney(this._extrasCents());
      if (delivRow) delivRow.hidden = false;
      if (delivLabel) delivLabel.textContent = S.perTotal || 'Totaal';
      if (monthEl) monthEl.textContent = '—';
      if (delivEl) delivEl.textContent = totalCents > 0 ? this._formatMoney(totalCents) : '—';
      this._renderShipNote(mb + ex, totalCents);
      if (cross) {
        const ref = this._aboReference(mb);
        if (ref && mb > 0) {
          const n = Math.max(mb, ref.tier.minBoxes);
          cross.textContent = (S.crossOnce || 'Als abonnement kost dezelfde koffie {month} per maand — {cup} per kopje{from}.')
            .replace('{month}', this._formatMoney(this._boxCents(ref.tier) * n))
            .replace('{cup}', this._formatMoney(Math.floor(this._boxCents(ref.tier) / this.data.cupsPerBox)))
            .replace('{from}', ref.belowMin ? (S.crossOnceFrom || ' (vanaf {n} doosjes)').replace('{n}', ref.tier.minBoxes) : '');
          cross.hidden = false;
        } else { cross.textContent = ''; cross.hidden = true; }
      }
      return;
    }
    this._renderShipNote(0, 0);
    if (extrasRow) extrasRow.hidden = true;
    if (delivRow) delivRow.hidden = (this.state.freq === 1);
    if (delivLabel) {
      delivLabel.textContent = (S.perDelivery || 'Per levering ({n} doosjes)').replace('{n}', mb * this.state.freq);
    }
    if (!tier) {
      if (cupEl) cupEl.textContent = '—';
      if (monthEl) monthEl.textContent = '—';
      if (delivEl) delivEl.textContent = '—';
      if (cross) { cross.textContent = ''; cross.hidden = true; }
      return;
    }
    const boxCents = this._boxCents(tier);
    const monthCents = boxCents * mb;
    if (cupEl) {
      const listPerCup = Math.floor(this.data.basePriceCents / this.data.cupsPerBox);
      cupEl.innerHTML = this._formatMoney(Math.floor(boxCents / this.data.cupsPerBox)) +
        ' <s>' + this._formatMoney(listPerCup) + '</s> <em>−' + (tier.savePct || 0) + '%</em>';
    }
    if (monthEl) monthEl.textContent = this._formatMoney(monthCents);
    if (delivEl) delivEl.textContent = this._formatMoney(monthCents * this.state.freq);
    if (cross) {
      const onceCents = this.data.basePriceCents * mb;
      cross.textContent = (S.crossAbo || 'Eenmalig kost deze doos {once} — met je abonnement bespaar je {save} per maand.')
        .replace('{once}', this._formatMoney(onceCents)).replace('{save}', this._formatMoney(onceCents - monthCents));
      cross.hidden = false;
    }
  }
  // Verzendmelding bij het totaal: alleen bij eenmalig én onder de gratis-verzendgrens.
  _renderShipNote(count, totalCents) {
    const el = this.root.querySelector('.qbb7-shipnote');
    if (!el) return;
    const free = this.data.freeShipCents || 4900;
    const show = this.state.freq === 0 && count > 0 && totalCents < free;
    el.textContent = show ? (S.shipNote || '+ verzendkosten — gratis vanaf €49') : '';
    el.hidden = !show;
  }
  _updateCta(mb, tier) {
    this._renderTotals(mb, tier);
    const permoEl = this.ctaBtn.querySelector('.qbb7-cta-permo');
    if (permoEl) permoEl.hidden = (this.state.freq === 0);
    const label = this.ctaBtn.querySelector('.bab__cta-label');
    const priceEl = this.ctaBtn.querySelector('.bab__cta-price');
    const priceWrap = this.ctaBtn.querySelector('.qbb7-cta-amount');
    if (this.state.freq === 0) {
      // Eenmalig: geen selling plan nodig, dus klaar zodra er iets in de doos zit.
      const total = this._onceTotalCents();
      const readyOnce = total > 0;
      this.ctaBtn.disabled = !readyOnce;
      this.ctaBtn.setAttribute('aria-disabled', readyOnce ? 'false' : 'true');
      if (!readyOnce) {
        if (label) label.textContent = S.ctaMinOnce || 'Kies minimaal 1 doosje';
        if (priceWrap) priceWrap.hidden = true;
      } else {
        if (label) label.textContent = this._editMode ? (S.ctaSave || 'Wijzigingen opslaan') : (S.ctaOnce || 'In winkelwagen');
        if (priceWrap) priceWrap.hidden = false;
        if (priceEl) priceEl.textContent = this._formatMoney(total);
      }
      if (this.ctaSub) this.ctaSub.textContent = '';
      this._planNote(null);
      return;
    }
    const planReady = !!(tier && tier.sellingPlanId);
    const ready = planReady && mb > 0;
    this.ctaBtn.disabled = !ready;
    this.ctaBtn.setAttribute('aria-disabled', ready ? 'false' : 'true');
    if (!tier) {
      if (label) label.textContent = (S.ctaMin || 'Kies minimaal {n} cups per maand').replace('{n}', this._minBoxes() * this.data.cupsPerBox);
      if (priceWrap) priceWrap.hidden = true;
      if (this.ctaSub) this.ctaSub.textContent = '';
      this._planNote(null);
      return;
    }
    if (label) label.textContent = this._editMode ? (S.ctaSave || 'Wijzigingen opslaan') : (S.ctaStart || 'Start mijn abonnement');
    if (priceWrap) priceWrap.hidden = false;
    const monthCents = this._boxCents(tier) * mb;
    if (priceEl) priceEl.textContent = this._formatMoney(monthCents);
    if (this.ctaSub) { this.ctaSub.textContent = ''; }
    this._planNote(tier.sellingPlanId ? null : tier.planName);
  }
  _planNote(planName) {
    let note = this.root.querySelector('.qbb7-note');
    if (planName) {
      if (!note) {
        note = document.createElement('p');
        note.className = 'qbb7-note';
        this.ctaBtn.closest('.bab__cta').appendChild(note);
      }
      note.textContent = (S.planMissing || 'Selling plan „{plan}” bestaat nog niet in Juo — bestellen is daarom hier nog uitgeschakeld.').replace('{plan}', planName);
    } else if (note) { note.remove(); }
  }
  _formatMoney(cents) {
    const fmt = this.data.moneyFormat;
    if (fmt) {
      const amount = (cents / 100).toFixed(2).replace('.', ',');
      const amountDot = (cents / 100).toFixed(2);
      return fmt
        .replace('{{amount_with_comma_separator}}', amount)
        .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100).toString())
        .replace('{{amount_no_decimals}}', Math.round(cents / 100).toString())
        .replace('{{amount}}', amountDot);
    }
    return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  // ---- mandje ----
  _bindCta() { this.ctaBtn.addEventListener('click', () => this._addToCart()); }
  async _loadFromCart() {
    const cart = await fetch('/cart.js').then(r => r.json());
    // Eenmalige regels dragen _once (geen _box), abo-regels dragen _box.
    const boxLines = (cart.items || []).filter(it => it.properties && (it.properties._box === this._editBoxId || it.properties._once));
    if (boxLines.length === 0) throw new Error('box not found in cart');
    let coffeeLines = boxLines.filter(it => it.selling_plan_allocation && it.product_type !== 'Machines' && !(it.properties && it.properties._free_gift === 'true'));
    let freq;
    if (coffeeLines.length > 0) {
      const spId = coffeeLines[0].selling_plan_allocation && coffeeLines[0].selling_plan_allocation.selling_plan && coffeeLines[0].selling_plan_allocation.selling_plan.id;
      const tier = this.data.tiers.find(t => String(t.sellingPlanId) === String(spId));
      freq = tier ? tier.freq : (this.data.defaultFreq || 2);
    } else {
      // Regels ZONDER selling plan (_once, of oude _box-regels zonder plan) = eenmalig (freq 0).
      coffeeLines = boxLines.filter(it => !it.selling_plan_allocation && it.product_type !== 'Machines' && !(it.properties && it.properties._free_gift === 'true'));
      if (coffeeLines.length === 0) throw new Error('no editable coffee lines');
      freq = 0;
    }
    this._initQtys();
    coffeeLines.forEach(line => {
      const vid = String(line.variant_id);
      if (Object.prototype.hasOwnProperty.call(this.state.qtys, vid)) {
        this.state.qtys[vid] += Math.round(line.quantity / (freq || 1));
      }
    });
    this.state.freq = freq;
    if (freq) this._aboFreq = freq;
    this._syncFreqButtons();
    this._render();
    this._showEditBanner();
  }
  _showEditBanner() {
    if (this.root.querySelector('.bab__edit-banner')) return;
    const banner = document.createElement('p');
    banner.className = 'bab__edit-banner';
    banner.style.cssText = 'background:rgba(32,64,40,.08);color:#204028;border:1px solid rgba(32,64,40,.2);border-radius:8px;padding:9px 12px;font-size:13px;margin:0 0 14px;';
    banner.textContent = S.editBanner || 'Je past je huidige box aan. Pas de smaken, de hoeveelheid of het ritme aan en sla op — je winkelwagen wordt automatisch bijgewerkt.';
    this.root.insertBefore(banner, this.root.firstChild);
  }
  async _addToCart() {
    // Eenmalig (freq 0): zelfde smaakregels plus de specialties, maar ZONDER selling plan, zonder
    // welkomstcadeau en zonder cadeaucode — volle prijs, één zending. Eenmalige regels
    // krijgen _once:'1' in plaats van _box, anders groepeert de drawer ze onder het abo.
    // Abonnement: alleen de koffie; specialties gaan nooit mee in een abo-mandje.
    const once = this.state.freq === 0;
    const tier = once ? null : this._activeTier();
    if (!once && (!tier || !tier.sellingPlanId)) return;
    const items = [];
    this.data.products.forEach(product => {
      if (product.extra && !once) return;
      const monthly = this.state.qtys[String(product.variantId)] || 0;
      const qty = monthly * (once ? 1 : this.state.freq);
      if (qty > 0) {
        const line = {
          id: product.variantId,
          quantity: qty,
          properties: once ? { '_once': '1' } : {
            '_box': 'box-' + this.data.parentProductId,
            '_parent_product_handle': this.data.parentProductHandle,
            '_parent_product_id': String(this.data.parentProductId),
          },
        };
        if (!once) line.selling_plan = tier.sellingPlanId;
        items.push(line);
      }
    });
    if (items.length === 0) return;
    // Welkomstcadeau: zonder selling plan -> eenmalige mandjesregel, dus automatisch alleen
    // de eerste levering. Hangt aan de staffel. Ook bij BEWERKEN reconciliëren we het cadeau
    // met de nieuwe staffel: _removeOldBoxLines(true) haalt eerst álle regels van deze box weg
    // (ook oude cadeauregels), daarna zetten we hier de cadeauset van de nieuwe staffel terug
    // en zet _applyGiftDiscount de bijbehorende code (of ruimt hem op). Eenmalig: nooit cadeau.
    const gifts = once ? [] : (tier.giftVariantIds || []).filter(Boolean);
    const includeGifts = gifts.length > 0;
    if (includeGifts) {
      gifts.forEach(freeVid => {
        items.push({ id: freeVid, quantity: 1, properties: {
          '_box': 'box-' + this.data.parentProductId,
          '_parent_product_handle': this.data.parentProductHandle,
          '_parent_product_id': String(this.data.parentProductId),
          '_free_gift': 'true',
        }});
      });
    }
    this.ctaBtn.disabled = true;
    this.ctaBtn.classList.add('bab__cta-btn--loading');
    const originalText = this.ctaBtn.innerHTML;
    this.ctaBtn.textContent = this.data.loadingText || 'Bijna klaar...';
    let snapshot = null;
    try {
      const cartDrawerSectionId = document.querySelector('cart-drawer')?.closest('.shopify-section')?.id?.replace('shopify-section-', '');
      if (this._editMode) {
        snapshot = await this._snapshotBoxLines();
        await this._removeOldBoxLines(true);
      }
      const res = await this._cartRequest('/cart/add.js', { items: items });
      if (!res || !res.ok) {
        let msgText = 'Cart add failed';
        if (res && res.status === 422) {
          const errBody = await res.json().catch(() => ({}));
          if (errBody.description) { msgText = errBody.description; }
        }
        throw new Error(msgText);
      }
      const addData = await res.json();
      await this._applyGiftDiscount(tier, includeGifts);
      if (!this._editMode && this.data.afterAddAction === 'checkout') {
        window.location.href = qdRoot() + 'checkout';
        return;
      }
      try {
        const cartContent = await fetch('/cart.js').then(r => r.json());
        if (cartDrawerSectionId) {
          const freshSections = await fetch(qdRoot() + 'cart?sections=' + cartDrawerSectionId).then(r => r.json()).catch(() => null);
          if (freshSections) cartContent.sections = freshSections;
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cartContent } }));
        document.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: addData.items || [addData] } }));
      } catch (uiErr) {
        console.warn('[QdBuyBox14] weergave-verversing mislukt, terugvallen op winkelwagen:', uiErr);
        window.location.href = qdRoot() + 'cart';
        return;
      }
      this.ctaBtn.innerHTML = originalText;
      this.ctaBtn.classList.remove('bab__cta-btn--loading');
      this._render();
    } catch (err) {
      console.error('[QdBuyBox14] Cart add error:', err);
      if (snapshot) { await this._restoreBoxLines(snapshot).catch(() => {}); }
      this.ctaBtn.innerHTML = originalText;
      this.ctaBtn.disabled = false;
      this.ctaBtn.classList.remove('bab__cta-btn--loading');
      const isEN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
      let msg = (err && err.message) || '';
      if (!msg || /did not match the expected pattern|Load failed|JSON Parse|Failed to fetch|NetworkError|Cart add failed|Cart update failed|Cart unavailable/i.test(msg)) {
        msg = S.errorGeneric || (isEN ? 'Something went wrong while saving. Your cart is unchanged — please try again.' : 'Er ging iets mis bij het opslaan. Je winkelwagen is niet gewijzigd — probeer het opnieuw.');
      }
      this._showError(msg);
    }
  }
  async _cartRequest(path, payload) {
    let res = null;
    for (let attempt = 0; attempt < 3; attempt++) {
      try {
        res = await fetch(path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) });
      } catch (e) { res = null; }
      if (res && res.ok) return res;
      if (res && res.status < 500 && res.status !== 429) return res;
      await new Promise(resolve => setTimeout(resolve, 600 * (attempt + 1)));
    }
    return res;
  }
  async _cartJson() {
    for (let attempt = 0; attempt < 3; attempt++) {
      try { return await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json()); }
      catch (e) { await new Promise(resolve => setTimeout(resolve, 400 * (attempt + 1))); }
    }
    throw new Error('Cart unavailable');
  }
  async _snapshotBoxLines() {
    const cart = await this._cartJson();
    return (cart.items || [])
      .filter(it => it.properties && it.properties._box === this._editBoxId)
      .map(it => ({ id: it.variant_id, quantity: it.quantity, properties: it.properties, ...(it.selling_plan_allocation ? { selling_plan: it.selling_plan_allocation.selling_plan.id } : {}) }));
  }
  async _restoreBoxLines(snapshot) {
    if (!snapshot || !snapshot.length) return;
    const cart = await this._cartJson();
    const present = (cart.items || []).some(it => it.properties && it.properties._box === this._editBoxId && it.selling_plan_allocation);
    if (present) return;
    const leftovers = {};
    (cart.items || []).forEach(it => { if (it.properties && it.properties._box === this._editBoxId) { leftovers[it.key] = 0; } });
    if (Object.keys(leftovers).length) { await this._cartRequest('/cart/update.js', { updates: leftovers }); }
    await this._cartRequest('/cart/add.js', { items: snapshot });
  }
  // Cadeaucode op het mandje zetten; oude plan/cadeaucodes opruimen; klantcodes blijven staan.
  async _applyGiftDiscount(tier, includeGifts) {
    try {
      const LEGACY_AND_GIFT_CODES = [
        'Een maand: 12% korting + Energy cadeau',
        'Drie maanden: 20% korting + 3 cadeaus',
        '€80 korting op Morning Mini + 22% korting op koffie',
        '€300 korting op Morning Machine + 25% korting op koffie',
        'One month: 12% discount + free gift',
        '3 months: 20% discount + free gifts',
        '€80 discount on Morning Mini + 22% discount on coffee',
        '€300 discount on Morning Machine + 25% discount on coffee',
        'Gratis bij een maand koffieabonnement',
        'Welkomstcadeau Energy',
        'Welkomstcadeau proeverij'
      ];
      const cart = await this._cartJson();
      const current = (cart.discount_codes || []).map(d => d.code);
      const wanted = current.filter(c => LEGACY_AND_GIFT_CODES.indexOf(c) === -1);
      if (includeGifts && tier.giftCode) { wanted.push(tier.giftCode); }
      if (wanted.join(',') !== current.join(',')) {
        await this._cartRequest('/cart/update.js', { discount: wanted.join(',') });
      }
      if (includeGifts && tier.giftCode) { await fetch('/discount/' + encodeURIComponent(tier.giftCode), { redirect: 'follow' }).catch(() => {}); }
    } catch (e) { console.warn('[QdBuyBox14] cadeaucode bijwerken mislukt:', e); }
  }
  async _removeOldBoxLines(removeAll) {
    const cart = await this._cartJson();
    const keys = (cart.items || [])
      .filter(it => {
        if (!it.properties || it.properties._box !== this._editBoxId) return false;
        if (removeAll) return true;
        return it.selling_plan_allocation && it.product_type !== 'Machines' && !(it.properties._free_gift === 'true');
      })
      .map(it => it.key);
    if (!keys.length) return;
    const updates = {};
    keys.forEach(k => { updates[k] = 0; });
    const removeRes = await this._cartRequest('/cart/update.js', { updates: updates });
    if (!removeRes || !removeRes.ok) { throw new Error('Cart update failed'); }
  }
  _showError(message) {
    let errEl = this.root.querySelector('.bab__error');
    if (!errEl) {
      errEl = document.createElement('p');
      errEl.className = 'bab__error';
      errEl.style.cssText = 'color:#c0392b;font-size:13px;margin:8px 0 0;text-align:center;';
      this.ctaBtn.closest('.bab__cta').appendChild(errEl);
    }
    errEl.textContent = message;
    setTimeout(() => { if (errEl.parentNode) errEl.remove(); }, 5000);
  }
}
function boot() { if (window.__qbb7Data) { new QdBuyBox14(); } }
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
